export default __webpack_public_path__ + "static/media/p7.5260394c.jpg";